var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_RoleSelection"),
        width: "260px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticStyle: { "margin-left": "10px" } },
        [
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.selectedPositions,
                callback: function($$v) {
                  _vm.selectedPositions = $$v
                },
                expression: "selectedPositions"
              }
            },
            _vm._l(_vm.positionCasts, function(position) {
              return _c(
                "div",
                {
                  key: position.code,
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "align-items": "center"
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: {
                        "margin-top": "8px",
                        "margin-bottom": "8px",
                        "word-wrap": "break-word",
                        "white-space": "normal",
                        "word-break": "normal",
                        display: "flex",
                        "flex-direction": "row",
                        "justify-content": "center"
                      },
                      attrs: { label: position.code }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "12px" } }, [
                        _vm._v(_vm._s(position.chineseName))
                      ])
                    ]
                  )
                ],
                1
              )
            }),
            0
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "confirm", type: "primary" },
              on: { click: _vm.enterHandler }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }